export default "__VITE_ASSET__950db059__"